import { createFileRoute } from '@tanstack/react-router';
import { getAuthtoken } from 'stores/useAuthStore';
import Connectors from 'containers/Connectors';
import {
  connectorTypesQueryOptions,
  connectorsQueryOptions,
} from 'containers/Connectors/useConnectors';

export const Route = createFileRoute('/_authenticated/connectors')({
  loader: ({ context }) => {
    const authToken = getAuthtoken();
    return Promise.all([
      context.queryClient.prefetchQuery(connectorsQueryOptions(authToken)),
      context.queryClient.prefetchQuery(
        connectorTypesQueryOptions(authToken)
      ),
    ]);
  },
  component: Connectors,
});
